import type { NextPage } from "next";
import dynamic from "next/dynamic";

import Page from "components/layout/page";
import NextSectionAction from "components/next-section-action";
import Benefits from "components/views/virtual-sales-rep/benefits";
import KeyFeatures from "components/views/virtual-sales-rep/key-features";
import MainHero from "components/views/virtual-sales-rep/main-hero";
import MeetVsr from "components/views/virtual-sales-rep/meet-vsr";
import StreamlineSalesFunnel from "components/views/virtual-sales-rep/streamline-sales-funnel";
import WhyVsr from "components/views/virtual-sales-rep/why";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const VirtualSalesRep: NextPage = () => (
  <Page
    title="Enerflo VSR | Virtual Sales Rep & Inside Sales for Solar"
    description="Enerflo VSR automates solar lead capture, qualification, and instant quotes—helping installers scale marketing and speed-to-lead without added overhead."
  >
    <MainHero />
    <MeetVsr />
    <StreamlineSalesFunnel />
    <KeyFeatures />
    <Benefits />
    <WhyVsr />
    <NextSectionAction
      buttonText="View Reporting & Analytics"
      url="/features/reporting"
      description="Dominate with AI-powered insights"
    />
    <DemoFormSection />
  </Page>
);

export default VirtualSalesRep;
